module.exports = __webpack_public_path__ + "static/media/email-icon.8306aa32.svg";